import React, { memo } from "react";
import { Card, Steps, Divider, Row, Col, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import PickupDropOffSteps from "../PickupDropOffSteps";
import { VehiclesTable } from "../Tables";
import GoogleMap from "../GoogleMap";
import "./Card.styles.css";
import ETAsDescription from "../ETAsDescription";

const { Title } = Typography;

export default memo(function PostedCard({
  pickupAddress,
  dropOffAddress,
  vehicles,
}) {
  return (
    <Card>
      <div style={{ width: "100%", textAlign: "center" }}>
        <Title level={3}>Posted</Title>
      </div>
      <Steps
        style={{
          marginBottom: 32,
          justifyContent: "center",
        }}
        current={0}
      >
        <Steps.Step
          title="Awaiting Transporter"
          icon={<LoadingOutlined style={{ color: "#4888FA" }} />}
          status="process"
        />
      </Steps>
      <Divider
        style={{
          marginBottom: 32,
        }}
      />
      <PickupDropOffSteps
        pickupAddress={pickupAddress}
        dropOffAddress={dropOffAddress}
      />
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <VehiclesTable data={vehicles} isPosted />
        </Col>
        <Col xs={24} sm={24} md={12}>
          <GoogleMap
            pickupAddress={pickupAddress}
            dropOffAddress={dropOffAddress}
          />
        </Col>
      </Row>
      <Divider
        style={{
          marginBottom: 32,
        }}
      />
      <ETAsDescription loadStatus={null} />
      <Divider
        style={{
          marginBottom: 32,
        }}
      />
    </Card>
  );
});
